function init () {
  document.querySelectorAll('.asset-focus-point').forEach((image) => {
    image.style.objectPosition = image.dataset.focuspoint || 'center center'
    if (window.innerWidth <= 1280 && image.dataset.focuspointMobile) {
      image.style.objectPosition = image.dataset.focuspointMobile || 'center center'
    }
  })
}

export default {
  init,
}
